import { useBackend } from "../../services";

export const useCreateMercadoPagoPurchasePreference = () => {
  const { post } = useBackend();
  const createMercadoPagoPurchasePreference = async (
    parameters: ICreateMercadoPagoPurchasePreferenceParameters
  ) => {
    return post("mercadopago/preference", parameters);
  };
  return { createMercadoPagoPurchasePreference };
};

export interface ICreateMercadoPagoPurchasePreferenceParameters {
  productId: string;
}
